import { transformSharePermissionsToServer } from '@atlassian/jira-common-directory-v2/src/services/transformers';
import type { OperationData } from '@atlassian/jira-shareable-entity-dialog';
import type { CopyFilterRequestBody } from '../types';

export const transformCopyFilter = (
	filter: OperationData,
	jql: string,
	isFavourite: boolean,
): CopyFilterRequestBody => {
	const { description, name, owner, editPermissions, sharePermissions } = filter;
	const result: CopyFilterRequestBody = {
		name,
		description,
		favourite: isFavourite,
		jql,
		sharePermissions: transformSharePermissionsToServer(sharePermissions || [], true),
		editPermissions: transformSharePermissionsToServer(editPermissions || [], true),
	};

	if (owner) {
		result.owner = {
			accountId: owner.accountId,
		};
	}

	return result;
};
